module.exports = __webpack_public_path__ + "static/media/app-3.64ce0605.jpg";